import { fromJS } from "immutable";


const initFilterNonRef = fromJS({
  customerCode: "",
  customerName: "",
  materialCode: "",
  materialDesc: "",
  salesOffice: "",
  distChannel: "",
  pageNo: 1,
  pageSize: 10,
});

export function filterDataNonRef(state = initFilterNonRef, action) {
  switch (action.type) {
    case "FILTER_SET_CUSTOMER_CODE_SUCCESS":
      return state.set("customerCode", action.customerCode);
    case "FILTER_SET_CUSTOMER_NAME_SUCCESS":
      return state.set("customerName", action.customerName);
    case "FILTER_SET_MATERIAL_CODE_SUCCESS":
      return state.set("materialCode", action.materialCode);
    case "FILTER_SET_MATERIAL_DESCRIPTION_SUCCESS":
      return state.set("materialDescription", action.materialDescription);
    case "FILTER_SET_SALES_DIVISION_SUCCESS":
      return state.set("salesOffice", action.salesOffice);
    case "FILTER_SET_DIST_CHANNEL_SUCCESS":
      return state.set("distChannel", action.distChannel);
    case "FILTER_SET_PAGE_NO_SUCCESS":
      return state.set("pageNo", action.pageNo);
    case "FILTER_SET_PAGE_SIZE_SUCCESS":
      return state.set("pageSize", action.pageSize);
    default:
      return state;
  }
}

export function nonRefDetails(state = fromJS([]), action) {
  switch (action.type) {
    case "NON_REF_DETAILS_FETCH":
      return fromJS(action.detail);
    default:
      return state;
  }
}

export function nonRefDetailsTemp(state = fromJS([]), action) {
  switch (action.type) {
    case "NON_REF_DETAILS_FETCH_TEMP":
      return fromJS(action.detail);
    default:
      return state;
  }
}


export function nonRefFrom(state = '', action) {
  switch (action.type) {
    case "NON_REF_FROM_PAGE":
      return action.page;
    default:
      return state;
  }
}